import { Component } from "react";
import { connect } from "react-redux";
import {
  Table,
  Card,
  Tag,
  Input,
  Button,
  Tooltip,
  Modal,
  Alert,
  Image,
} from "antd";
import {
  req_list_pim_overtime_range_self,
  req_list_pim_overtime_total_self,
  req_list_pim_takeleave_range_self,
  req_list_pim_overtime_month_settle,
} from "../../api";
import {
  formateHHMMDate,
  getCurrentMonthFirstDay,
  getCurrentMonthLastDay,
} from "../../utils/dateUtil";
import { usrRole } from "../../utils/dataUtil";
import WeekendOvertimeApplyModal from "./weekend-overtime-apply-modal";
import OverTimeSelfCoverAddModal from "./over-time-self-cover-add-modal";
import OvertimeOffsetSelfModal from "./overtime-offset-self-modal";
import { API_BASE } from "../../utils/contrains";

class OverTimeLogSelf extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: window.innerWidth,
    startDate: getCurrentMonthFirstDay(),
    endDate: getCurrentMonthLastDay(),
    timeTotal: 0,
    modify: true,
    loading: false,
    lock: false,
    userLevel: "NORMAL",
    data: [],
    data_ext: [],
    item: {},
    isShowWeekendOvertimeApplyModal: false,
    isShowOvertimeApplyModal: false,
    isShowOffsetModal: false,
    OverTimeMonth: "",
    OffsetHoursAndMinutes: "",
  };

  UNSAFE_componentWillMount() {
    window.removeEventListener("resize", this.resize.bind(this));
    this.init_columns();
    this.init_columns_ext();
  }
  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_item_list();
    this.api_item_ext_list();
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_item_month_overtime = async () => {
    const { startDate, endDate } = this.state;
    const { token, role, userCode } = this.props.user;
    let month = startDate.substring(0, 6);
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const result = await req_list_pim_overtime_month_settle(
      userLevel,
      userCode,
      "StaffCode",
      userCode,
      month,
      token
    );
    if (result.total > 0) {
      const overtime_item = result.data[0];
      //  console.log(overtime_item);
      const { OverTimeMonth, OffsetHoursAndMinutes } = overtime_item;
      this.setState({
        OverTimeMonth,
        OffsetHoursAndMinutes,
        item: overtime_item,
      });
    } else {
      this.setState({
        OverTimeMonth: "",
        OffsetHoursAndMinutes: "",
        item: {},
      });
    }

    const timeTotal = await req_list_pim_overtime_total_self(
      userCode,
      startDate,
      endDate,
      token
    );
    this.setState({
      timeTotal: timeTotal,
    });
  };

  api_item_list = async () => {
    const { searchField, searchValue, startDate, endDate } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, loading: true, data: [] });
    this.api_item_month_overtime();
    const result = await req_list_pim_overtime_range_self(
      userLevel,
      userCode,
      startDate,
      endDate,
      searchField,
      searchValue,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items, loading: false });
      //console.log(items);
    } else {
      const items = [];
      this.setState({
        data: items,
        loading: false,
      });
    }

    const timeTotal = await req_list_pim_overtime_total_self(
      userCode,
      startDate,
      endDate,
      token
    );
    this.setState({
      timeTotal: timeTotal,
    });
  };

  api_item_ext_list = async () => {
    const { searchField, searchValue, startDate, endDate } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, loading: true, data_ext: [] });
    const result = await req_list_pim_takeleave_range_self(
      userLevel,
      userCode,
      startDate,
      endDate,
      searchField,
      searchValue,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data_ext: items });
      // console.log(items);
    } else {
      const items = [];
      this.setState({
        data_ext: items,
        // loading: false,
      });
    }
  };

  // 樣式設定 //////////////////////////////////////////////
  statusApplyDescription = (Status) => {
    switch (Status) {
      case "APPLY":
        return "申請中";
      case "AY":
        return "單位二級主管通過";
      case "BY":
        return "單位一級主管通過";
      case "CY":
        return "人事室承辦人通過";
      case "DY":
        return "人事室承辦主管通過";
      case "EY":
        return "人事室主任通過";
      case "ALLAGREE":
        return "申請已通過";
      case "AN":
        return "單位二級主管未通過";
      case "BN":
        return "單位一級主管未通過";
      case "CN":
        return "人事室承辦人未通過";
      case "DN":
        return "人事室承辦主管未通過";
      case "EN":
        return "人事室主任未通過";
      case "ZN":
        return "註銷";
      default:
        return "申請未通過";
    }
  };

  style_switch_color_tag(column, param) {
    switch (column) {
      case "REASON":
        switch (param) {
          case "工作日":
            return "blue";
          case "休息日":
            return "green";
          case "例假日":
          case "國定假日":
          case "停班停課":
          case "休息日加班":
            return "red";
          case "休假日":
            return "gold";
          case "平假日調換":
            return "purple";
          case "工作日調移":
            return "Tan";
          case "工作日加班":
            return "orange";
          default:
            return "default";
        }
      case "TYPE_APPLY":
        switch (param) {
          case "補簽到退申請":
            return "blue";
          case "工作日加班申請":
            return "orange";
          case "休息日加班申請":
            return "red";
          case "平假日調換申請":
            return "purple";
          case "工作日調移申請":
            return "Tan";
          default:
            return "default";
        }
      case "WEEK":
        switch (param) {
          case "週一":
          case "週二":
          case "週三":
          case "週四":
          case "週五":
            return "blue";
          case "週六":
            return "green";
          case "週日":
            return "red";
          default:
            return "default";
        }
      case "STATUS_WORK":
        switch (param) {
          case "PASS":
            return "red";
          case "WORK":
            return "blue";
          default:
            return "blue";
        }
      case "STATUS_APPLY":
        switch (param) {
          case "APPLY":
            return "blue";
          case "AY":
            return "blue";
          case "BY":
            return "blue";
          case "CY":
            return "blue";
          case "DY":
            return "blue";
          case "EY":
            return "blue";
          case "ALLAGREE":
            return "green";
          case "AN":
            return "red";
          case "BN":
            return "red";
          case "CN":
            return "red";
          case "DN":
            return "red";
          case "EN":
            return "red";
          case "ZN":
            return "red";
          default:
            return "blue";
        }
      case "STATUS_CONFIRM":
        switch (param) {
          case "NO":
            return "red";
          case "YES":
            return "green";
          default:
            return "default";
        }
      default:
        return "blue";
    }
  }

  convertMinutesToHoursAndMinutes = (minutes) => {
    let hours = Math.floor(minutes / 60);
    let remainingMinutes = minutes % 60;
    return `${hours} 小時 ${remainingMinutes} 分鐘`;
  };

  formatYearMonth = (str) => {
    if (str.length === 6) {
      let year = str.substring(0, 4);
      let month = str.substring(4, 6);
      return `${year}年${month}月` + "：已抵扣";
    } else {
      return "";
    }
  };

  // 操作互動處理 //////////////////////////////////////////////
  handle_data_refresh = () => {
    this.api_item_list();
    this.api_item_ext_list();
  };

  // 欄位設定 /////////////////////////////////////////////////
  init_columns = () => {
    this.columns = [
      {
        title: "申請分類",
        dataIndex: "OvertimeReason",
        key: "OvertimeReason",
        align: "center",
        width: 100,
        render: (text) => (
          <>
            <Tag color={this.style_switch_color_tag("REASON", text)}>
              {text}
            </Tag>
          </>
        ),
      },
      {
        title: "審查狀況",
        dataIndex: "ApplyStatus",
        key: "ApplyStatus",
        align: "center",
        width: 100,
        render: (text) => (
          <>
            <Tag color={this.style_switch_color_tag("STATUS_APPLY", text)}>
              {this.statusApplyDescription(text)}
            </Tag>
          </>
        ),
      },
      {
        title: "職工姓名",
        dataIndex: "StaffName",
        key: "StaffName",
        align: "center",
        width: 100,
        render: (text) => <>{text}</>,
      },
      {
        title: "加班日期",
        dataIndex: "OvertimeDate",
        key: "OvertimeDate",
        align: "center",
        width: 80,
        render: (text) => <>{text}</>,
      },
      {
        title: "起始時間",
        dataIndex: "OvertimeClockStart",
        key: "OvertimeClockStart",
        align: "center",
        width: 80,
        render: (text) => <>{formateHHMMDate(text)}</>,
      },
      {
        title: "結束時間",
        dataIndex: "OvertimeClockEnd",
        key: "OvertimeClockEnd",
        align: "center",
        width: 80,
        render: (text) => <>{formateHHMMDate(text)}</>,
      },
      {
        title: "核准分鐘",
        dataIndex: "AgreeMinutes",
        key: "AgreeMinutes",
        align: "center",
        width: 80,
        render: (text) => <>{text}分</>,
      },
      {
        title: "申請說明",
        width: 100,
        render: (item) => {
          const url = item.ReasonFileUrl;
          const isPdf = url && url.toLowerCase().endsWith(".pdf");

          const handleClick = (e) => {
            e.preventDefault();
            if (isPdf) {
              window.open(API_BASE + url, "_blank", "noopener,noreferrer");
            }
          };

          return (
            <>
              {url ? (
                isPdf ? (
                  <a
                    href={API_BASE + url}
                    onClick={handleClick}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ cursor: "pointer" }}
                  >
                    <i
                      className="fas fa-file-pdf"
                      style={{ fontSize: 20, color: "#d9534f" }}
                    ></i>
                  </a>
                ) : (
                  <Image
                    width={25}
                    height={25}
                    src={API_BASE + url}
                  />
                )
              ) : null}
              {item.RecordDescription}
            </>
          );
        },
      },
    ];
  };

  init_columns_ext = () => {
    this.columns_ext = [
      {
        title: "休假分類",
        dataIndex: "takeLeaveType",
        key: "takeLeaveType",
        align: "center",
        width: 100,
        render: (text) => <>{text}</>,
      },
      {
        title: "職工姓名",
        dataIndex: "StaffTwName",
        key: "StaffTwName",
        align: "center",
        width: 100,
        render: (text) => <>{text}</>,
      },
      {
        title: "申請日期",
        dataIndex: "takeLeaveApplyTime",
        key: "takeLeaveApplyTime",
        align: "center",
        width: 100,
        render: (text) => <>{text}</>,
      },
      {
        title: "起始時間",
        dataIndex: "takeLeaveTimeStart",
        key: "takeLeaveTimeStart",
        align: "center",
        width: 100,
        render: (text) => <>{text}</>,
      },
      {
        title: "結束時間",
        dataIndex: "takeLeaveTimeEnd",
        key: "takeLeaveTimeEnd",
        align: "center",
        width: 100,
        render: (text) => <>{text}</>,
      },
      {
        title: "時數",
        dataIndex: "compensatoryTotal",
        key: "compensatoryTotal",
        width: 50,
        render: (text) => <>{text}</>,
      },
      {
        title: "說明",
        dataIndex: "takeLeaveMeno",
        key: "takeLeaveMeno",
        width: 200,
        render: (text) => <>{text}</>,
      },
    ];
  };

  ///////////////////////////////////////////////////////////
  render() {
    const {
      data,
      data_ext,
      loading,
      isShowWeekendOvertimeApplyModal,
      isShowOvertimeApplyModal,
      isShowOffsetModal,
      startDate,
      endDate,
      timeTotal,
      OverTimeMonth,
      OffsetHoursAndMinutes,
      item,
    } = this.state;
    const title = (
      <div>
        <Input
          placeholder="起始年月日"
          style={{ width: 100, margin: "0 5px" }}
          value={startDate}
          onChange={(event) => this.setState({ startDate: event.target.value })}
        />
        <Input
          placeholder="結束年月日"
          style={{ width: 100, margin: "0 5px" }}
          value={endDate}
          onChange={(event) => this.setState({ endDate: event.target.value })}
        />
        <Button type="primary" onClick={() => this.handle_data_refresh()}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Button type="primary" onClick={() => this.handle_data_refresh()}>
          <i className="fas fa-sync-alt"></i>
        </Button>{" "}
        <Tooltip placement="top" title="休息日(週六)預劃來校加班">
          <Button
            type="primary"
            onClick={() =>
              this.setState({ isShowWeekendOvertimeApplyModal: true })
            }
            danger
          >
            <i className="fas fa-calendar-plus"></i>
            <span style={{ marginLeft: "4px" }}>休息日預請加班</span>
          </Button>
        </Tooltip>{" "}
        <Tooltip placement="top" title="申請事後補登加班時數">
          <Button
            color="cyan"
            onClick={() => this.setState({ isShowOvertimeApplyModal: true })}
          >
            <i className="fas fa-calendar-plus"></i>
            <span style={{ marginLeft: "4px" }}>補登加班時數申請</span>
          </Button>
        </Tooltip>{" "}
      </div>
    );
    return (
      <Card>
        {title}
        <Table
          bordered
          rowKey="Uid"
          columns={this.columns}
          dataSource={data}
          pagination={false}
          loading={loading}
        />
        <div>
          <Alert
            message={
              <>
                <span style={{ fontWeight: "bold", color: "green" }}>
                  已核定加班時數：{" "}
                  {this.convertMinutesToHoursAndMinutes(timeTotal)}
                </span>
                <hr></hr>
                <span style={{ fontWeight: "bold", color: "blue" }}>
                  {this.formatYearMonth(OverTimeMonth)}
                  {OffsetHoursAndMinutes}
                </span>
                {OffsetHoursAndMinutes === "" ? (
                  ""
                ) : (
                  <button
                    className="btn btn-info btn-sm"
                    style={{ marginLeft: "5px", marginTop: "5px" }}
                    onClick={() => {
                      this.setState({ isShowOffsetModal: true });
                    }}
                  >
                    <i
                      class="fas fa-user-clock"
                      style={{ marginRight: "2px" }}
                    ></i>{" "}
                    查看
                  </button>
                )}
              </>
            }
            type="success"
          />
        </div>
        <Modal
          destroyOnClose={true}
          visible={isShowWeekendOvertimeApplyModal}
          width={300}
          onOk={() => {
            this.setState({ isShowWeekendOvertimeApplyModal: false });
            this.handle_data_refresh();
          }}
          okText={"關閉"}
          onCancel={() => {
            this.setState({ isShowWeekendOvertimeApplyModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <WeekendOvertimeApplyModal />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isShowOvertimeApplyModal}
          width={300}
          onOk={() => {
            this.setState({ isShowOvertimeApplyModal: false });
            this.handle_data_refresh();
          }}
          okText={"關閉"}
          onCancel={() => {
            this.setState({ isShowOvertimeApplyModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <OverTimeSelfCoverAddModal />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isShowOffsetModal}
          width={500}
          onOk={() => {
            this.setState({ isShowOffsetModal: false });
          }}
          okText={"關閉"}
          onCancel={() => {
            this.setState({ isShowOffsetModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <OvertimeOffsetSelfModal data={item} />
        </Modal>
        <div
          style={{ marginTop: "20px", fontWeight: "bold", fontSize: "1.2em" }}
        >
          <i className="fas fa-clipboard-list"></i> 過往補休紀錄
        </div>
        <Table
          bordered
          columns={this.columns_ext}
          dataSource={data_ext}
          pagination={false}
          loading={loading}
        />
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(OverTimeLogSelf);
